import { useMemo } from "react";

import { useEmbedParametersContext } from "../contexts/EmbedParametersContext";
import { snowplowAnalyticsExists } from "../helpers/analyticsHelpers";
import { usePlayerStore } from "../store/usePlayerStore";

export const useSnowplowEnabled = (): boolean => {
  const { getState } = usePlayerStore();
  const embedParams = useEmbedParametersContext();

  return useMemo(() => {
    return (
      snowplowAnalyticsExists() &&
      __SNOWPLOW_ENABLED &&
      !!embedParams.analytics &&
      !getState().isCasting
    );
  }, [embedParams, getState]);
};
